export default {
  minYear: 1100,
  maxYear: 2030
}